// import * as THREE from "three";
// import { Line, Text } from "@react-three/drei";
// import { useMemo, useCallback, useState, useEffect } from "react";
// import { eventEmiterInstance } from "../../../utils/EventEmitter";
// import { createRectanglePoints } from "../utils";
// import { GradientMaterial } from "./Area";

// // Helper: Darken a color
// function darkenColor(hex, percent = 0.25) {
//   const c = new THREE.Color(hex);
//   const hsl = {};
//   c.getHSL(hsl);
//   hsl.l *= 1 - percent;
//   return new THREE.Color().setHSL(hsl.h, hsl.s, hsl.l).getStyle();
// }

// const SubArea = ({ isWareHouseInventoryRoute, subArea, obj, w, d, areaLocationsToHighlight = {} }) => {
//   const [selectedSubAreaId, setSelectedSubAreaId] = useState(null);
//   const [hoveredArea, setHoveredArea] = useState(false);
//   const [showLabel, setShowLabel] = useState(false);
//   const [selectedArea, setSelectedArea] = useState(null);

//   const points = useMemo(() => createRectanglePoints(w, d), [w, d]);

//   // const subPos = useMemo(() => subArea.position.map((v, i) => v - obj.position[i]), [subArea.position, obj.position]);
//   // const subPos = useMemo(() => subArea.position, [subArea.position]);

//   // console.log("subPos", subPos);

//   const areaLocationsSet = useMemo(() => new Set(areaLocationsToHighlight.areaLocations || []), [areaLocationsToHighlight.areaLocations]);

//   const isHighlighted = areaLocationsSet.has(subArea.code);
//   const primaryColor = areaLocationsToHighlight.primaryColor;

//   const highlightColors = useMemo(() => {
//     if (isHighlighted && subArea.tags?.length > 0) {
//       return subArea.tags.map((t) => t.color).filter(Boolean);
//     }
//     return null;
//   }, [isHighlighted, subArea.tags]);

//   const shouldUseGradient = highlightColors?.length > 1;

//   const baseColor = useMemo(() => {
//     if (isHighlighted) {
//       if (subArea.tags?.length > 0) return subArea.tags[0].color;
//       return primaryColor;
//     }
//     return subArea.color || obj.color;
//   }, [isHighlighted, subArea.color, obj.color, subArea.tags, primaryColor]);

//   const sideColor = useMemo(() => darkenColor(baseColor, 0.3), [baseColor]);

//   const fillColor = hoveredArea ? "hotpink" : baseColor;

//   const handlePointerOver = useCallback((e) => {
//     e.stopPropagation();
//     setHoveredArea(true);
//   }, []);

//   const handlePointerOut = useCallback((e) => {
//     e.stopPropagation();
//     setHoveredArea(false);
//   }, []);

//   const handleAreaSelection = useCallback(
//     (selection) => {
//       setSelectedSubAreaId(selection?.subAreaId ?? null);
//       setSelectedArea(selection?.areaId ?? null);
//       setShowLabel(selection?.subAreaId === subArea.id);
//     },
//     [subArea.id]
//   );

//   useEffect(() => {
//     eventEmiterInstance.on("selection", handleAreaSelection);
//     return () => eventEmiterInstance.off("selection", handleAreaSelection);
//   }, [handleAreaSelection]);

//   const onSubAreaClick = useCallback(
//     (event) => {
//       event.stopPropagation();

//       if ((selectedSubAreaId === subArea.id || selectedArea === obj.id) && isWareHouseInventoryRoute) {
//         eventEmiterInstance.emit("showSubAreaInfo", subArea);
//       } else {
//         setSelectedSubAreaId(subArea.id);
//       }

//       eventEmiterInstance.emit("selection", { areaId: obj.id, subAreaId: subArea.id, subArea });
//     },
//     [selectedSubAreaId, selectedArea, obj.id, subArea, isWareHouseInventoryRoute]
//   );

//   // ⬆ SubArea thickness
//   const depth = 0.15;
//   const sideHeight = 0.14;
//   const sideT = 0.02;

//   return (
//     <group position={subArea.position}>
//       {/* MAIN BASE (3D) */}
//       <mesh rotation={[-Math.PI / 2, 0, 0]} position={[0, depth / 2, 0]}>
//         <boxGeometry args={[w, d, depth]} />
//         {shouldUseGradient ? (
//           <GradientMaterial colors={highlightColors} opacity={1} />
//         ) : (
//           <meshStandardMaterial color={fillColor} metalness={0.25} roughness={0.7} />
//         )}
//       </mesh>

//       {/* SIDES — darker tone */}
//       {/* Front */}
//       <mesh position={[0, sideHeight / 2, -d / 2]}>
//         <boxGeometry args={[w, sideHeight, sideT]} />
//         <meshStandardMaterial color={sideColor} metalness={0.3} roughness={0.8} />
//       </mesh>

//       {/* Back */}
//       <mesh position={[0, sideHeight / 2, d / 2]}>
//         <boxGeometry args={[w, sideHeight, sideT]} />
//         <meshStandardMaterial color={sideColor} metalness={0.3} roughness={0.8} />
//       </mesh>

//       {/* Left */}
//       <mesh position={[-w / 2, sideHeight / 2, 0]}>
//         <boxGeometry args={[sideT, sideHeight, d]} />
//         <meshStandardMaterial color={sideColor} metalness={0.3} roughness={0.8} />
//       </mesh>

//       {/* Right */}
//       <mesh position={[w / 2, sideHeight / 2, 0]}>
//         <boxGeometry args={[sideT, sideHeight, d]} />
//         <meshStandardMaterial color={sideColor} metalness={0.3} roughness={0.8} />
//       </mesh>

//       {/* CLICK + HOVER DETECTOR (thin plane above) */}
//       <mesh
//         rotation={[-Math.PI / 2, 0, 0]}
//         position={[0, depth + 0.001, 0]}
//         onClick={onSubAreaClick}
//         onPointerOver={handlePointerOver}
//         onPointerOut={handlePointerOut}
//       >
//         <planeGeometry args={[w, d]} />
//         <meshBasicMaterial transparent opacity={0} />
//       </mesh>

//       {/* TOP OUTLINE */}
//       <group rotation={[-Math.PI / 2, 0, 0]} position={[0, depth + 0.002, 0]}>
//         <Line points={points} color="black" lineWidth={1} />
//       </group>

//       {/* LABEL */}
//       {showLabel && (
//         <Text
//           position={[0, depth + 0.05, 0]}
//           rotation={[-Math.PI / 2, 0, 0]}
//           fontSize={Math.min(w, d) * 0.2}
//           color="black"
//           maxWidth={Math.min(w, d) * 0.9}
//           anchorX="center"
//           anchorY="middle"
//         >
//           {subArea.code}
//         </Text>
//       )}
//     </group>
//   );
// };

// export default SubArea;

import * as THREE from "three";
import { Line, Text } from "@react-three/drei";
import { useMemo, useCallback, useState, useEffect } from "react";
import { eventEmiterInstance } from "../../../utils/EventEmitter";
import { createRectanglePoints } from "../utils";
import { GradientMaterial } from "./Area";

function darkenColor(hex, percent = 0.25) {
  const c = new THREE.Color(hex);
  const hsl = {};
  c.getHSL(hsl);
  hsl.l *= 1 - percent;
  return new THREE.Color().setHSL(hsl.h, hsl.s, hsl.l).getStyle();
}

const SubArea = ({ isWareHouseInventoryRoute, subArea, obj, w, d, position = [0, 0, 0], areaLocationsToHighlight = {} }) => {
  const [selectedSubAreaId, setSelectedSubAreaId] = useState(null);
  const [hoveredArea, setHoveredArea] = useState(false);
  const [showLabel, setShowLabel] = useState(false);
  const [selectedArea, setSelectedArea] = useState(null);

  const points = useMemo(() => createRectanglePoints(w, d), [w, d]);

  const areaLocationsSet = useMemo(() => new Set(areaLocationsToHighlight.areaLocations || []), [areaLocationsToHighlight.areaLocations]);

  const isHighlighted = areaLocationsSet.has(subArea.code);
  const primaryColor = areaLocationsToHighlight.primaryColor;

  const highlightColors = useMemo(() => {
    if (isHighlighted && subArea.tags?.length > 0) {
      return subArea.tags.map((t) => t.color).filter(Boolean);
    }
    return null;
  }, [isHighlighted, subArea.tags]);

  const shouldUseGradient = highlightColors?.length > 1;

  const baseColor = useMemo(() => {
    if (isHighlighted) {
      if (subArea.tags?.length > 0) return subArea.tags[0].color;
      return primaryColor;
    }
    return subArea.color || obj.color;
  }, [isHighlighted, subArea.color, obj.color, subArea.tags, primaryColor]);

  const sideColor = useMemo(() => darkenColor(baseColor, 0.3), [baseColor]);

  const fillColor = hoveredArea ? "hotpink" : baseColor;

  const handlePointerOver = useCallback((e) => {
    e.stopPropagation();
    setHoveredArea(true);
  }, []);

  const handlePointerOut = useCallback((e) => {
    e.stopPropagation();
    setHoveredArea(false);
  }, []);

  const handleAreaSelection = useCallback(
    (selection) => {
      setSelectedSubAreaId(selection?.subAreaId ?? null);
      setSelectedArea(selection?.areaId ?? null);
      setShowLabel(selection?.subAreaId === subArea.id);
    },
    [subArea.id]
  );

  useEffect(() => {
    eventEmiterInstance.on("selection", handleAreaSelection);
    return () => eventEmiterInstance.off("selection", handleAreaSelection);
  }, [handleAreaSelection]);

  const onSubAreaClick = useCallback(
    (event) => {
      event.stopPropagation();

      if ((selectedSubAreaId === subArea.id || selectedArea === obj.id) && isWareHouseInventoryRoute) {
        eventEmiterInstance.emit("showSubAreaInfo", subArea);
      } else {
        setSelectedSubAreaId(subArea.id);
      }

      eventEmiterInstance.emit("selection", { areaId: obj.id, subAreaId: subArea.id, subArea });
    },
    [selectedSubAreaId, selectedArea, obj.id, subArea, isWareHouseInventoryRoute]
  );

  const depth = 0.15;
  const sideHeight = 0.14;
  const sideT = 0.02;

  return (
    <group position={position}>
      {/* MAIN BASE (3D) */}
      <mesh rotation={[-Math.PI / 2, 0, 0]} position={[0, depth / 2, 0]}>
        <boxGeometry args={[w, d, depth]} />
        {shouldUseGradient ? (
          <GradientMaterial colors={highlightColors} opacity={1} />
        ) : (
          <meshStandardMaterial color={fillColor} metalness={0.25} roughness={0.7} />
        )}
      </mesh>

      {/* SIDES — darker tone */}
      {/* Front */}
      <mesh position={[0, sideHeight / 2, -d / 2]}>
        <boxGeometry args={[w, sideHeight, sideT]} />
        <meshStandardMaterial color={sideColor} />
      </mesh>

      {/* Back */}
      <mesh position={[0, sideHeight / 2, d / 2]}>
        <boxGeometry args={[w, sideHeight, sideT]} />
        <meshStandardMaterial color={sideColor} />
      </mesh>

      {/* Left */}
      <mesh position={[-w / 2, sideHeight / 2, 0]}>
        <boxGeometry args={[sideT, sideHeight, d]} />
        <meshStandardMaterial color={sideColor} />
      </mesh>

      {/* Right */}
      <mesh position={[w / 2, sideHeight / 2, 0]}>
        <boxGeometry args={[sideT, sideHeight, d]} />
        <meshStandardMaterial color={sideColor} />
      </mesh>

      {/* CLICK + HOVER DETECTOR (thin plane above) */}
      <mesh
        rotation={[-Math.PI / 2, 0, 0]}
        position={[0, depth + 0.001, 0]}
        onClick={onSubAreaClick}
        onPointerOver={handlePointerOver}
        onPointerOut={handlePointerOut}
      >
        <planeGeometry args={[w, d]} />
        <meshBasicMaterial transparent opacity={0} />
      </mesh>

      {/* TOP OUTLINE */}
      <group rotation={[-Math.PI / 2, 0, 0]} position={[0, depth + 0.002, 0]}>
        <Line points={points} color="black" lineWidth={1} />
      </group>

      {/* LABEL */}
      {showLabel && (
        <Text
          position={[0, depth + 0.05, 0]}
          rotation={[-Math.PI / 2, 0, 0]}
          fontSize={Math.min(w, d) * 0.2}
          color="black"
          maxWidth={Math.min(w, d) * 0.9}
          anchorX="center"
          anchorY="middle"
        >
          {subArea.code}
        </Text>
      )}
    </group>
  );
};

export default SubArea;
